module.exports = __webpack_public_path__ + "img/ico-excel-black.ee249efd.svg";